<div class="final-bid-container" style="display: flex; flex-direction: column;">
<div class="new-layout-box-arrematar" *ngIf="vehicle.bidOption != 'ONLY_BID'">
    <div class="title-box">
      <i class="admin-icon-new-arramatar" style="margin-right: 8px;"></i>
      <p>Comprar agora por</p>
    </div>
    <div class="col-md-12 warning-box final-bid-error" *ngIf="finalBidErrorMessage && disableConfirmationModal">
      <div class="d-flex">
        <i class="material-icons">warning</i><strong>Houve um problema com a sua oferta</strong>
      </div>
      <div>
        {{finalBidErrorMessage}}
      </div>
    </div>

    <div class="container-value">
      <div class="value">
        <span class="currency-symbol">R$ </span>
        {{vehicle.finishValue | number}}
      </div>

      <ng-container *ngIf="user && user.isDealer()">
        <button class="btn btn-branded5 btn-rounded btn-lg btn-block text-white btn-buy-now"
          *ngIf="!showAlternativeBidForm"
          (click)="(disableConfirmationModal ? makeFinalBid() : openFinalBidModal()); $event.stopPropagation();">
          COMPRE JÁ!
        </button>


        <div class="description" *ngIf="disableConfirmationModal">
          Com a confirmação da compra, este veículo será seu sem a necessidade de esperar o fim do período da
          negociação e será emitido uma fee plataforma
          <ng-container *ngIf="vehicle.comissionValueConfig.type === 'PERCENTAGE'">de
            {{vehicle.comissionValueConfig.value | number: '1.1-2'}}% do valor do veículo</ng-container>
          <ng-container *ngIf="vehicle.comissionValueConfig.type !== 'PERCENTAGE'">de R$
            {{vehicle.comissionValueConfig.value | number: '1.2-2'}} </ng-container>
          (fee plataforma Auto Arremate).
        </div>
      </ng-container>
    </div>
</div>

<div class="modal-backdrop fade in" [style.display]="showFinalBidModal ? 'block' : 'none'"></div>
<div class="modal fade" [ngClass]="{'show': showFinalBidModal, 'hide': !showFinalBidModal}"
  *ngIf="user && user.isDealer()" [style.display]="showFinalBidModal ? 'block' : 'none'" (click)="closeFinalBidModal()">

  <div class="modal-dialog modal-dialog-centered" (click)="false; $event.stopPropagation();">
    <div class="modal-content box-arrematar">
      <div class="modal-header">
        <h5 class="title-box">
          <i class="app-icon-hammer" style="margin-right: 8px;"></i>
          Comprar agora por
        </h5>
        <button type="button" class="close" data-dismiss="modal" (click)="closeFinalBidModal()">
          <i class="material-icons">close</i>
        </button>

      </div>
      <div class="modal-body">
        <div class="col-md-12 warning-box final-bid-error" *ngIf="finalBidErrorMessage">
          <div class="d-flex">
            <i class="material-icons">warning</i><strong>Houve um problema com a sua oferta</strong>
          </div>
          <div>
            {{finalBidErrorMessage}}
            <ng-container *ngIf="showLatePaymentLink"><a [routerLink]="['/arrematar/arrematados']"
                [queryParams]="latePaymentQueryParams">Veja
                aqui</a> seus veículos com fee plataforma pendente.</ng-container>
          </div>
        </div>
        <div class="value" *ngIf="!finalBidErrorMessage">
          <span class="currency-symbol">R$ </span>
          {{vehicle.finishValue | number}}
        </div>

      </div>
      <div class="modal-footer" *ngIf="!finalBidErrorMessage">

        <button class="btn btn-branded5 btn-rounded btn-lg btn-block text-white" (click)="makeFinalBid()"
          [disabled]="loading">
          <div class="btn-spinner float-left" *ngIf="loading"></div>
          CONFIRMAR COMPRA
        </button>

        <div class="description">
          Com a confirmação da compra, este veículo será seu sem a necessidade de esperar o fim do período da
          negociação e será emitido uma fee plataforma
          <ng-container *ngIf="vehicle.comissionValueConfig.type === 'PERCENTAGE'">de
            {{vehicle.comissionValueConfig.value | number: '1.1-2'}}% do valor do veículo</ng-container>
          <ng-container *ngIf="vehicle.comissionValueConfig.type !== 'PERCENTAGE'">de R$
            {{vehicle.comissionValueConfig.value | number: '1.2-2'}} </ng-container>
          (Fee plataforma Auto Arremate).
        </div>

      </div>
    </div>
  </div>
</div>
</div>